<template>
  <div>
    <form id="file-form">
      <div class="file-field input-field">
        <div class="btn" @click="reading = true">
          <span>Upload Excel</span>
          <input type="file" v-on:change="readURL($event)" id="file-container" />
        </div>
        <div class="file-path-wrapper">
          <input class="file-path validate" type="text" />
        </div>
      </div>
    </form>
    <div v-if="processing" id="processing-counter">
      <div>Processing File...</div>
      <div class="progress">
        <div class="determinate" :style="{'width': processPercent + '%'}"></div>
      </div>
    </div>
    <div v-if="reading">
      <div>Reading file...</div>
    </div>
    <div id="settings-table">
      <table class="striped" v-if="settings.length">
        <thead>
          <tr>
            <th>Key</th>
            <th v-for="(lang,i) in languages" :key="i">{{lang}}</th>
            <th>Status</th>
          </tr>
        </thead>

        <tbody>
          <SystemSettingsItem v-for="(row, index) in settings" :key="index" :row="row" />
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import XLSX from "xlsx";
import SystemSettingsItem from "./SystemSettingsItem";
export default {
  name: "SystemSettingsUpload",
  props: {},
  components: {
    SystemSettingsItem,
  },
  data() {
    return {
      settings: [],
      languages: [],
      reading: false,
      processing: false,
      processPercent: 0,
      step: 0,
      langID:{},
    };
  },
  watch: {
    processPercent: function (val) {
      if (parseInt(Math.ceil(val)) == 100) {
        this.processing = false;
        this.reset();
        //Load Settings
        this.$parent.getTextSettings();
      }
    },
    "settings.length": function (val) {
      if (val != 0) {
        this.reading = false;
        this.processing = true;
      }
    },
  },
  methods: {
    reset() {
      this.settings = [];
      this.reading = false;
      this.processing = false;
      this.processPercent = 0;
      this.step = 0;
      this.langID = {},
      document.getElementById("file-form").reset();
      M.toast({ html: "File Processed", classes: "green" });
    },
    readURL(input) {
      input = input.target;
      if (input.files && input.files[0]) {
        this.reading = true;
        var reader = new FileReader();
        reader.onload = (e) => {
          var data = e.target.result;
          let workbookA = XLSX.read(data, { sheetRows: 1, type: "binary" });
          let sheetsList = workbookA.SheetNames;
          let sheetData = XLSX.utils.sheet_to_json(
            workbookA.Sheets[sheetsList[0]],
            {
              header: 1,
              defval: "",
              blankrows: true,
            }
          );
          sheetData[0].shift();
          this.languages = sheetData[0];
          var workbook = XLSX.read(data, {
            type: "binary",
          });
          //   workbook.SheetNames.forEach(function (sheetName) {
          //     var XL_row_object = XLSX.utils.sheet_to_row_object_array(
          //       workbook.Sheets[sheetName]
          //     );
          //     var json_object = JSON.stringify(XL_row_object);
          //     console.table(json_object);
          //   });
          var firstSheet = workbook.SheetNames[0];
          var excelRows = XLSX.utils.sheet_to_row_object_array(
            workbook.Sheets[firstSheet]
          );
          this.step = (1 / excelRows.length) * 100;
          this.languages.forEach(lang => {
            var language = this.$store.languages.filter(l => l.name.toUpperCase().includes(lang.toUpperCase()))[0];
            //Check if language exists in store with initials mentioned in excel
            if(language) this.langID[lang] = language.id;
          })
          this.displayTable(excelRows);
        };
        reader.readAsBinaryString(input.files[0]);
      }
    },
    displayTable(rows) {
      this.settings = rows;
      setTimeout(() => {
        var el = document.getElementById("processing-counter");
        el.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 500);
    },
  },
  mounted() {},
};
</script>
<style scoped>
</style>